import {Component, inject, OnInit} from '@angular/core';
import {NavigationComponent} from "../navigation/navigation.component";
import {DataService} from "../services/data.service";

@Component({
  selector: 'app-demo',
  imports: [NavigationComponent],
  templateUrl: './demo.component.html',
  styleUrl: './demo.component.scss'
})
export class DemoComponent implements OnInit {

    private dataService = inject(DataService);

    label = '';

    ngOnInit(): void {
        this.dataService.request('Code/getDemoLabel').subscribe(response => {
            this.label = response.label;
        });
    }
}
